import {
  Button,
  Center,
  Flex,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  useDisclosure,
} from '@chakra-ui/react'
import {Dancer} from 'models'
import {useEffect, useState} from 'react'
import {RiAddLine} from 'react-icons/ri'
import usePhaseData from '../../hooks/usePhaseData'
import {$, k} from '../../i18n/localization'
import ItemList from '../Common/ItemList'
import Store from 'lib/utils/Store'

interface Props {
  selected: Dancer[]
  saveDancers: (newDancers: Dancer[]) => void
}

const AddEditDancers = ({selected, saveDancers}: Props) => {
  const [selectedDancers, setSelectedDancers] = useState(selected)
  const {isOpen, onOpen, onClose} = useDisclosure({
    defaultIsOpen: Store.preserveModalState.isOpen.peek(),
  })
  const {disableAdminEditFeatures} = usePhaseData()

  useEffect(() => {
    Store.preserveModalState.isOpen.set(isOpen)
  }, [isOpen])

  useEffect(() => {
    setSelectedDancers(selected)
  }, [selected])

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size={['full', '2xl']}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{$(k.editDancers)}</ModalHeader>
          <ModalCloseButton />
          <ModalBody maxH={['80vh', '70vh']} paddingX={[1, 6]} overflowY='scroll' py={0}>
            <ItemList
              hideArrow={true}
              selectedDancers={selectedDancers}
              setSelectedDancers={setSelectedDancers}
            />
          </ModalBody>

          <ModalFooter>
            <Flex gap={5} w='full' justifyContent='space-evenly'>
              <Button variant='outline' onClick={onClose} flex={1}>
                {$(k.cancel)}
              </Button>
              <Button
                variant='primary'
                onClick={() => {
                  saveDancers(selectedDancers)
                  onClose()
                }}
                flex={1}>
                {$(k.edit)}
              </Button>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {disableAdminEditFeatures ? (
        <Spacer />
      ) : (
        <Center bgColor='gray.100' w='full' onClick={onOpen} py={4} borderRadius='xl'>
          <IconButton
            bgColor='white'
            variant='outline'
            aria-label='add edit'
            icon={<RiAddLine />}
          />
        </Center>
      )}
    </>
  )
}

export default AddEditDancers
